import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'

const styles = theme => ({
  root: {
    width: '100%'
  },
  focused: {
    '&:after': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  underline: {
    '&:before': {
      borderBottom: '2px solid #FFFFFF'
    }
  },
  input: {
    color: '#A6B9C8'
  }
})

class TextFieldComponent extends React.Component {
  render () {
    const { classes } = this.props
    if (this.props.hasError && this.props.value === '') {
      return (
        <div>
          <TextField
            error
            label={this.props.label}
            value={this.props.value}
            className={classes.root}
            onChange={(event) => this.props.onChange(event.target.value)}
            margin='normal'
            InputProps={{
              classes: this.props.classes
            }}
            InputLabelProps={{
              style: { color: '#F44335', fontSize: '14px', fontWeight: 500, fontStyle: 'normal' }
            }}
          />
        </div>
      )
    } else {
      return (
        <div>
          <TextField
            label={this.props.label}
            value={this.props.value}
            className={classes.root}
            onChange={(event) => this.props.onChange(event.target.value)}
            margin='normal'
            InputProps={{
              classes: this.props.classes
            }}
            InputLabelProps={{
              style: { color: '#A6B9C8', fontSize: '14px', fontWeight: 500, fontStyle: 'normal' }
            }}
          />
        </div>
      )
    }
  }
}

TextFieldComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(TextFieldComponent)
